import React from 'react';
import { PhoneCall, BookOpen, TrendingUp } from 'lucide-react';

const Sidebar = () => {
  return (
    <aside className="hidden md:flex flex-col w-64 h-full bg-white border-r border-slate-200 fixed left-0 top-0 z-20">
      {/* Logo */}
      <div className="p-6 flex items-center gap-3 border-b border-slate-100">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-semibold tracking-tight shadow-sm">
          S
        </div>
        <span className="text-base font-semibold tracking-tight text-slate-900">
          Savitskaya.ai
        </span>
      </div>

      {/* Info Section */}
      <div className="p-4 bg-blue-50 border-b border-blue-100">
        <h3 className="text-xs font-semibold text-blue-900 uppercase tracking-wider mb-1">
          Платформа обучения
        </h3>
        <p className="text-xs text-blue-700">
          Тренировка холодных звонков с AI
        </p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-2">
        <div className="flex items-center gap-3 px-3 py-2 text-sm text-blue-700 bg-blue-50 rounded-md font-medium border border-blue-100">
          <PhoneCall className="w-5 h-5 text-blue-600" />
          Тренировка
        </div>

        <div className="pt-2 pb-2">
          <h4 className="px-3 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
            Сценарии
          </h4>
          <div className="space-y-1">
            <div className="flex items-center gap-2 px-3 py-1.5 text-xs text-slate-600">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-400"></div>
              Работа с секретарем
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 text-xs text-slate-600">
              <div className="w-1.5 h-1.5 rounded-full bg-orange-400"></div>
              Разговор с ЛПР
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 text-xs text-slate-600">
              <div className="w-1.5 h-1.5 rounded-full bg-red-400"></div>
              Закрытие сделки
            </div>
          </div>
        </div>

        <div className="pt-2">
          <h4 className="px-3 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
            Ресурсы
          </h4>
          <a
            href="#"
            className="flex items-center gap-3 px-3 py-2 text-sm text-slate-500 hover:text-slate-900 hover:bg-slate-50 rounded-md transition-colors group"
          >
            <BookOpen className="w-4 h-4 text-slate-400 group-hover:text-blue-600 transition-colors" />
            Скрипты продаж
          </a>
          <a
            href="#"
            className="flex items-center gap-3 px-3 py-2 text-sm text-slate-500 hover:text-slate-900 hover:bg-slate-50 rounded-md transition-colors group"
          >
            <TrendingUp className="w-4 h-4 text-slate-400 group-hover:text-blue-600 transition-colors" />
            Моя статистика
          </a>
        </div>
      </nav>

      {/* User info */}
      <div className="p-4 border-t border-slate-100">
        <div className="flex items-center gap-3 p-2 rounded-md bg-slate-50">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-xs font-semibold">
            МН
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-medium text-slate-900">Менеджер</span>
            <span className="text-xs text-slate-500">В тренировке</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
